import React from 'react';

// High-visibility, dismissible bar promoting authenticator-app MFA for users still on
// the emailed code. Dismissal is per browser session (sessionStorage) — it reappears on
// their next login, since this is meant to keep nudging adoption without being permanent.
const DISMISS_KEY = 'mfaPromoBannerDismissed';

const MfaPromoBanner = ({ onSetUp, onDismiss }) => (
  <div
    style={{
      width: '100%',
      background: 'linear-gradient(90deg, #0d6efd, #6610f2)',
      color: '#fff',
      padding: '10px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      flexWrap: 'wrap',
      fontSize: '14px',
      position: 'relative',
      zIndex: 1050
    }}
  >
    <span>
      🔐 <strong>Get instant sign-in codes.</strong> Set up Google Authenticator, Microsoft Authenticator, or Duo — no more waiting on email.
    </span>
    <button
      type="button"
      onClick={onSetUp}
      style={{
        background: '#fff',
        color: '#0d6efd',
        border: 'none',
        borderRadius: '6px',
        padding: '4px 12px',
        fontWeight: 600,
        fontSize: '13px',
        cursor: 'pointer'
      }}
    >
      Set up now
    </button>
    <button
      type="button"
      onClick={onDismiss}
      aria-label="Dismiss"
      style={{
        background: 'transparent',
        border: 'none',
        color: '#fff',
        fontSize: '18px',
        lineHeight: 1,
        cursor: 'pointer',
        position: 'absolute',
        right: '12px',
        top: '50%',
        transform: 'translateY(-50%)'
      }}
    >
      ×
    </button>
  </div>
);

export function isMfaPromoBannerDismissed() {
  try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
}
export function dismissMfaPromoBanner() {
  try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* ignore */ }
}

export default MfaPromoBanner;
